import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import DeliveryShopSetAttributePage from "./pages/DeliveryShopSetAttributePage.vue";
import DeliveryModeListPage from "./pages/DeliveryModeListPage.vue";
import DeliveryMappingList from "./pages/DeliveryMappingList.vue";
import DeliveryRawStatusMapping from "./pages/DeliveryRawStatusMapping.vue";

export const DeliveryModeRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "delivery"
) => [
  {
    name: "DeliveryShopSetAttributePage",
    path: `${prefix}/set-attribute/:id`,
    component: DeliveryShopSetAttributePage,
    meta: { title: "Delivery Shop Set Attribute" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHOP_DELIVERY_SET_ATTRIBUTE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "DeliveryRawStatusMapping",
    path: `${prefix}/set-raw-status/:id`,
    component: DeliveryRawStatusMapping,
    meta: { title: "Delivery Set Raw Status" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.DELIVERY_RAW_STATUS_MAPPING
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "DeliveryModeListPage",
    path: `${prefix}`,
    component: DeliveryModeListPage,
    meta: { title: "Delivery Mode List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHOP_DELIVERY_SET_ATTRIBUTE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "DeliveryMappingList",
    path: `${prefix}/mapping`,
    component: DeliveryMappingList,
    meta: { title: "Delivery Raw Status Mapping" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.DELIVERY_RAW_STATUS_MAPPING
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
